module.exports = __webpack_public_path__ + "static/girlwithdog-e1f38286f1af7430a18af58ca3d56159.png";